var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "uf-drawer",
      attrs: {
        visible: _vm.innerVisible,
        direction: "rtl",
        size: "800px",
        "with-header": false,
        "modal-append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _vm.uf
        ? _c("div", { staticClass: "drawer-wrap" }, [
            _c("div", { staticClass: "drawer-header" }, [
              _c("div", { staticClass: "dh-left" }, [
                _c("div", { staticClass: "dh-uf" }, [_vm._v(_vm._s(_vm.uf))]),
                _c("div", { staticClass: "dh-text" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.companyName))]),
                  _c("div", { staticClass: "dh-sub" }, [
                    _c("span", [_vm._v("开票主体状态详情 · 双轨健康度")]),
                    _c("span", { staticClass: "dh-sub-pt" }, [
                      _vm._v(
                        "Detalhes da entidade emissora · saúde das duas trilhas"
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "drawer-close",
                  on: {
                    click: function ($event) {
                      _vm.innerVisible = false
                    },
                  },
                },
                [_vm._v("×")]
              ),
            ]),
            _c("div", { staticClass: "drawer-body" }, [
              _c("div", { staticClass: "drawer-section" }, [
                _c(
                  "span",
                  { staticClass: "status-pill", class: _vm.overall.cls },
                  [
                    _c("span", { staticClass: "dot" }),
                    _vm._v(_vm._s(_vm.overall.zh) + " "),
                    _c("span", { staticClass: "pill-pt" }, [
                      _vm._v("/ " + _vm._s(_vm.overall.pt)),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "dual-track" }, [
                  _c("div", { staticClass: "track-card" }, [
                    _c("div", { staticClass: "tc-label" }, [
                      _c("span", [_vm._v("税务资质（CNPJ/IE 接口）")]),
                      _c("span", { staticClass: "tc-pt" }, [
                        _vm._v("Qualificação Fiscal (API CNPJ/IE)"),
                      ]),
                    ]),
                    _c("div", { staticClass: "tc-status" }, [
                      _c(
                        "span",
                        { staticClass: "status-pill", class: _vm.taxLabel.cls },
                        [
                          _c("span", { staticClass: "dot" }),
                          _vm._v(_vm._s(_vm.taxLabel.zh) + " "),
                          _c("span", { staticClass: "pill-pt" }, [
                            _vm._v("/ " + _vm._s(_vm.taxLabel.pt)),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "track-card" }, [
                    _c("div", { staticClass: "tc-label" }, [
                      _c("span", [_vm._v("系统配置（CT-e/MDF-e 开票主体）")]),
                      _c("span", { staticClass: "tc-pt" }, [
                        _vm._v(
                          "Config. Sistema (entidade emissora de CT-e/MDF-e)"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "tc-status" }, [
                      _c(
                        "span",
                        { staticClass: "status-pill", class: _vm.sysLabel.cls },
                        [
                          _c("span", { staticClass: "dot" }),
                          _vm._v(_vm._s(_vm.sysLabel.zh) + " "),
                          _c("span", { staticClass: "pill-pt" }, [
                            _vm._v("/ " + _vm._s(_vm.sysLabel.pt)),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "drawer-section" }, [
                _c("h4", [
                  _c("span", [_vm._v("主体信息")]),
                  _c("span", { staticClass: "h4-pt" }, [
                    _vm._v("Informações da Entidade"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "info-list" },
                  _vm._l(_vm.infoRows, function (row) {
                    return _c("div", { key: row.key, staticClass: "il-row" }, [
                      _c("div", { staticClass: "il-k" }, [
                        _vm._v(" " + _vm._s(row.label)),
                        _c("span", { staticClass: "il-k-pt" }, [
                          _vm._v(_vm._s(row.labelPt)),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "il-v", class: { num: row.mono } },
                        [
                          row.key === "expire" && _vm.expireBadge
                            ? _c("span", { staticClass: "expire-line" }, [
                                _c("span", [_vm._v(_vm._s(row.value))]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "tag",
                                    class: _vm.expireTagCls,
                                  },
                                  [_vm._v(_vm._s(_vm.expireBadge))]
                                ),
                                _c("span", { staticClass: "il-v-pt" }, [
                                  _vm._v(_vm._s(row.valuePt)),
                                ]),
                              ])
                            : [
                                _c(
                                  "span",
                                  { class: { "is-empty": row.value === "—" } },
                                  [_vm._v(_vm._s(row.value))]
                                ),
                                row.valuePt
                                  ? _c("span", { staticClass: "il-v-pt" }, [
                                      _vm._v(_vm._s(row.valuePt)),
                                    ])
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _c(
                "div",
                { staticClass: "drawer-section" },
                [
                  _c("h4", [
                    _c("span", [_vm._v("近期变更（来自变更日志）")]),
                    _c("span", { staticClass: "h4-pt" }, [
                      _vm._v("Alterações recentes (do log de alterações)"),
                    ]),
                  ]),
                  _vm._l(_vm.recentChanges, function (c, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "chg-mini" },
                      [
                        _c("div", { staticClass: "cm-top" }, [
                          _c("span", [_vm._v(_vm._s(_vm.chgTime(c)))]),
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm.chgTriggerZh(c)) + " "),
                            _c("span", { staticClass: "pt" }, [
                              _vm._v(
                                "/ " + _vm._s(_vm.chgTriggerPt(c.triggerType))
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._l(c.changeFields || [], function (f, fi) {
                          return _c(
                            "div",
                            { key: fi, staticClass: "cm-flow" },
                            [
                              _c("span", { staticClass: "cm-field" }, [
                                _vm._v(_vm._s(f) + "："),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.valueOf(c.beforeValues, fi)) +
                                  " → " +
                                  _vm._s(_vm.valueOf(c.afterValues, fi)) +
                                  " "
                              ),
                            ]
                          )
                        }),
                        c.operatorName
                          ? _c("div", { staticClass: "cm-op" }, [
                              _vm._v(
                                " 操作人：" + _vm._s(c.operatorName) + " "
                              ),
                              _c("span", { staticClass: "pt" }, [
                                _vm._v("/ Operador: " + _vm._s(c.operatorName)),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  !_vm.recentChanges.length
                    ? _c("div", { staticClass: "chg-mini" }, [
                        _c("div", { staticClass: "cm-flow is-empty" }, [
                          _vm._v("暂无变更记录"),
                          _c("span", { staticClass: "pt" }, [
                            _vm._v("/ Nenhum registro de alteração"),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c(
              "div",
              { staticClass: "drawer-footer" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.innerVisible = false
                      },
                    },
                  },
                  [
                    _c("bi-label", {
                      attrs: { zh: "关闭", pt: "Fechar", inline: "" },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      type: "primary",
                      disabled: !_vm.queryId,
                      title: _vm.queryId
                        ? ""
                        : "该州无主体 ID，无法单条查询 / Sem ID da entidade",
                    },
                    on: { click: _vm.handleQuery },
                  },
                  [
                    _c("bi-label", {
                      attrs: { zh: "单条查询", pt: "Consultar", inline: "" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }